import { useLocation } from "react-router-dom";
import './loggedOut.css';

export default function Footer() {
    const location = useLocation();

    if (location.pathname === "/ContactUs") return null;
    if (location.pathname === "/SignIn") return null;
    return (
        <div className="logged-out">
            <section className="landing-cta py-4 text-white text-center" style={{ backgroundColor: "#FFDAC1" }}>
                <div className="container py-2" style={({ color: "#808080" })}>
                    <h3 className="mb-3">Ready to explore support with BCA</h3>
                    <p className="mb-4">Get in touch with our team to find out how we can support your goals.</p>
                    <div className="mt-4">
                        <a
                            href="/ContactUs"
                            className="btn btn-success me-3"
                            style={{
                                borderRadius: "999px",
                                padding: "0.6rem 1.6rem",
                            }}
                        >
                        Contact Now -&gt;
                        </a>
                    </div>

                </div>
            </section>
        </div>
    )
}
